export { default } from './AutoSizer';
export { default as AutoSizer } from './AutoSizer';


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/AutoSizer/index.js
// module id = E19O
// module chunks = 22